import React from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { withRouter } from "react-router-dom";

import {
  handleSaveAndExitClick,
  onSaveAndExitClick,
  scheduleActionCreators,
} from "../../store/actions/schedule";
import {
  isRouteSchedulingOpen,
  isRouteScheduling,
  formatScheduleResults,
  getScheduleError,
  getDrawerTitle,
  getCardTitle,
  getEnableRetry,
  isRouteSaveEnabled,
} from "../../store/selectors/schedule";
import {
  getTransferRouteId,
  isTransferRouteDefault,
} from "../../store/selectors/route";
import ScheduleRouteModal from "../../components/modals/ScheduleRoute";

import { SCHEDULE_MODAL } from "../../constants/analytics";

const ScheduleRouteContainer = (props) => {
  const {
    open,
    drawerTitle,
    cardTitle,
    showLoader,
    error,
    isRetryEnabled,
    scheduleResult: { leftData, rightData },
    onClose,
    onRetryClick,
    handleSaveClick,
    handleSaveAndExitClick,
    onResetClick,
    onMoreChangesClick,
    isSaveEnabled,
  } = props;

  return (
    <ScheduleRouteModal
      onClose={onClose}
      onRetryClick={onRetryClick}
      drawerTitle={drawerTitle}
      cardTitle={cardTitle}
      showLoader={showLoader}
      leftData={leftData}
      rightData={rightData}
      error={error}
      isRetryEnabled={isRetryEnabled}
      open={open}
      onSaveClick={handleSaveClick}
      onSaveAndExitClick={handleSaveAndExitClick}
      onResetClick={onResetClick}
      onMoreChangesClick={onMoreChangesClick}
      isMakeMoreChanges={true}
      isSaveEnabled={isSaveEnabled}
      loadId={SCHEDULE_MODAL.LOAD}
    />
  );
};

const mapStateToProps = (state) => ({
  open: isRouteSchedulingOpen(state),
  drawerTitle: getDrawerTitle(state),
  cardTitle: getCardTitle(state),
  showLoader: isRouteScheduling(state),
  error: getScheduleError(state),
  isRetryEnabled: getEnableRetry(state),
  transferRouteId: getTransferRouteId(state),
  isTransferToRouteDefault: isTransferRouteDefault(state),
  scheduleResult: formatScheduleResults(state),
  isSaveEnabled: isRouteSaveEnabled(state),
});

const mapDispatchToProps = (dispatch, { history }) => ({
  ...bindActionCreators(scheduleActionCreators, dispatch),
  handleSaveClick: () => dispatch(onSaveAndExitClick()),
  handleSaveAndExitClick: () => dispatch(handleSaveAndExitClick(history)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withTrackProps({
    handleSaveClick: SCHEDULE_MODAL.CLICK_SAVE,
    handleSaveAndExitClick: SCHEDULE_MODAL.CLICK_SAVE,
    onResetClick: SCHEDULE_MODAL.CLICK_RESET_ALL_CHANGES,
    onMoreChangesClick: SCHEDULE_MODAL.CLICK_MAKE_MORE_CHANGES,
    onClose: SCHEDULE_MODAL.CLICK_CLOSE,
  })
)(ScheduleRouteContainer);
